// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import SearchBox from '../../../shared/components/search-box';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import {mapSearchPlaceHolder} from '../../shared/services/product-search-helper';
import {secure} from '../../../shared/components/security-wrapper/secure';

const ProductSearchBox = props =>
    <SearchBox
        defaultOption={props.searchByDropDown.selectedOption.key}
        onOptionChange={props.updateSearchDropDown}
        onQueryChange={props.updateSearchQueryString}
        onSearch={props.handleSearch}
        placeholderText={mapSearchPlaceHolder(props.searchByDropDown.selectedOption.key)}
        queryString={props.searchQueryString}
        searchBy={props.searchByDropDown.searchBy}
    />;

ProductSearchBox.displayName = 'ProductSearchBox';
ProductSearchBox.propTypes = {
    handleSearch: PropTypes.func.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    updateSearchDropDown: PropTypes.func.isRequired,
    updateSearchQueryString: PropTypes.func.isRequired
};

export default secure('PRT', 'PRT_PRODUCT_SEARCH')(ProductSearchBox);



// WEBPACK FOOTER //
// ./src/product/shared/components/product-search-box.js